import React from 'react';

import { PageHeader } from '@components/PageHeader';

import { useThemeGetter } from '@hooks';

import { mainInfo } from '@consts';

import { CardContainer } from '@components/CardContainer';
import { DiplomasBox } from './DiplomasBox';
import { UniversityCard } from './UniversityCard';

export const EducationCard = () => {
  const {
    type,
    theme: {
      TitleReverse,
      TitleReverse02,
      Title: TitleColor,
      Text: TextColor,
      Background,
      BlockShadow,
      ElementShadow,
      Secondary,
    },
  } = useThemeGetter();

  return (
    <CardContainer>
      <PageHeader text="Education" headerColor={TitleReverse} />
      <UniversityCard
        themeType={type}
        titleColor={TitleColor}
        textColor={TextColor}
        background={Background}
        shadow={BlockShadow}
      />
      <DiplomasBox
        background={Background}
        blockShadow={BlockShadow}
        elementShadow={ElementShadow}
        titleReverse={TitleReverse02}
        textColor={TextColor}
        backgroundReverse={Secondary}
        diplomas={mainInfo.EDUCATION_INFO.diplomas}
      />
    </CardContainer>
  );
};
